import _node from "./node";
var exports = {};
let Node = _node;
class Comment extends Node {
  constructor(defaults) {
    super(defaults);
    this.type = "comment";
  }
}
exports = Comment;
Comment.default = Comment;
export default exports;